export const copyJson = $state({ data: {} })

export const sheetJson = $state({ data: {} })
export const introJson = $state({ data: {} })
